// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import GridHarnessPage from './pages/dev/GridHarnessPage';
import MainLayout from './layouts/MainLayout';
import PublicLayout from './layouts/PublicLayout';
import GlobalLayout from './layouts/GlobalLayout';
import { usePageTracking } from './hooks/useAnalytics';
import HomePage from './pages/HomePage';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import Terms from './pages/Terms';
import MediaPolicy from './pages/MediaPolicy';
import Dashboard from './pages/Dashboard';
import AccountNotSetUp from './pages/AccountNotSetUp';
import LoginPage from './pages/LoginPage';
import StyleGuide from './pages/StyleGuide';
import AuthLoginPage from './pages/auth/LoginPage';
import QrCheckInPage from './pages/QrCheckInPage';
import CheckinScanPage from './pages/CheckinScanPage';
import PublicSchedulePage from './pages/PublicSchedulePage';
import PublicEventTeamPage from './pages/PublicEventTeamPage';
import PublicBracketsPage from './pages/PublicBracketsPage';
import PublicVenuesPage from './pages/PublicVenuesPage';
import PublicUnsubscribePage from './pages/PublicUnsubscribePage';

import PublicScoreboardPage from './pages/PublicScoreboardPage';
import PublicStandingsPage from './pages/PublicStandingsPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import EventPage from './pages/public/EventPage';
import EventExtrasPage from './pages/public/EventExtrasPage';
import MyDigitalWalletPage from './pages/public/MyDigitalWalletPage';
import PurchaseReceiptPage from './pages/public/PurchaseReceiptPage';
import ScheduleRequestsPage from './pages/public/ScheduleRequestsPage';
import SchedulingResponsePage from './pages/public/SchedulingResponsePage';
// (cross-event public pages — replaces removed per-event versions)
import SpectatorTicketPurchase from './pages/SpectatorTicketPurchase';
import SpectatorTicketSuccess from './pages/SpectatorTicketSuccess';
import DemoEvents from './pages/demo/DemoEvents';
import DemoLoginPage from './pages/demo/DemoLoginPage';
import { DemoProvider } from './contexts/DemoContext';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import SetPassword from './pages/athlete/SetPassword';
import EmailVerificationPage from './pages/EmailVerificationPage';
import Pricing from './pages/Pricing';
import VideoMarketplace from './pages/VideoMarketplace';
import VideoHoopsRecaps from './pages/VideoHoopsRecaps';
import VideoHoopsWatch from './pages/VideoHoopsWatch';
import VideoMembershipPurchase from './pages/VideoMembershipPurchase';
import VideoMembershipSuccess from './pages/VideoMembershipSuccess';
import VideosManagement from './pages/admin-dashboard/VideosManagement';
import Coaches from './pages/Coaches';
import Softball from './pages/Softball';
import Hoops from './pages/Hoops';
import BoysCircuit from './pages/BoysCircuit';
import GirlsCircuit from './pages/GirlsCircuit';
import LarryHughesEliteCamp from './pages/LarryHughesEliteCamp';
import MayLivePeriodKC from './pages/events/MayLivePeriodKC';

import JuniorsCircuit from './pages/JuniorsCircuit';
import Scouts from './pages/Scouts';
import AthleteDashboard from './pages/modules/AthleteDashboard';
import ParentDashboard from './pages/ParentDashboard';
import ParentAthleteEdit from './pages/parent/ParentAthleteEdit';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PublicRoute from './components/auth/PublicRoute';
import { Toaster } from 'sonner';
import RecruitingTrackerSummary from './pages/modules/RecruitingTrackerSummary';
import TeamNeedsPublicPage from './pages/public/TeamNeedsPublicPage';
import AdminEventDetails from './pages/admin/AdminEventDetails';
import EventManagement from './pages/admin/EventManagement';
import DemoDataPage from './pages/demo/DemoDataPage';
import DemoHubPage from './pages/demo/DemoHubPage';
import DemoLayout from './layouts/DemoLayout';
import MobileEventsApp from './mobile/events/MobileEventsApp';
import DemoTournaments from './pages/demo/DemoTournaments';
import DemoEventManagement from './pages/demo/DemoEventManagement';
import DemoEventManagementRedirect from './pages/demo/DemoEventManagementRedirect';
import DemoRegistrations from './pages/demo/DemoRegistrations';
import DemoCheckIn from './pages/demo/DemoCheckIn';
import DemoScoring from './pages/demo/DemoScoring';
import DemoScoringRedirect from './pages/demo/DemoScoringRedirect';
import DemoPackets from './pages/demo/DemoPackets';
import DemoPacketGenerator from './pages/demo/DemoPacketGenerator';
import DemoStaffing from './pages/demo/DemoStaffing';
import DemoOfficials from './pages/demo/DemoOfficials';
import DemoScorekeepers from './pages/demo/DemoScorekeepers';
import DemoTravel from './pages/demo/DemoTravel';
import DemoInventory from './pages/demo/DemoInventory';
import DemoChecklists from './pages/demo/DemoChecklists';
import DemoLeaderboards from './pages/demo/DemoLeaderboards';
import DemoScheduling from './pages/demo/DemoScheduling';
import DemoCreateEvent from './pages/demo/DemoCreateEvent';
import EventPricingConfig from './pages/admin/EventPricingConfig';
import EventRegistrationsAdmin from './pages/admin/EventRegistrationsAdmin';
import EventRostersAdmin from './pages/admin/EventRostersAdmin';
import EventCheckInPage from './pages/admin/EventCheckInPage';
import SubmitFeedback from './pages/athlete-dashboard/feedback/submit/[token]';
import ProfileActivity from './pages/modules/ProfileActivity';
import RecruitingAssistant from './pages/modules/RecruitingAssistant';
import RecruitingCalendar from './pages/modules/RecruitingCalendar';
import FafsaHelper from './pages/modules/FafsaHelper';
import NcaaGlossary from './pages/modules/NcaaGlossary';
import TrainingDashboard from './pages/modules/TrainingDashboard';
import PersonalityAssessment from './pages/modules/PersonalityAssessment';
import PersonalityResults from './pages/modules/PersonalityResults';
import MyTeamsPage from './pages/modules/MyTeamsPage';
import NewTeamPage from './pages/teams/NewTeamPage';
import TeamDetailPage from './pages/teams/TeamDetailPage';
import AcceptTeamInvitePage from './pages/invites/AcceptTeamInvitePage';
import TeamBillingPublicPage from './pages/pay/TeamBillingPublicPage';
import EventRegistrationPage from './pages/events/EventRegistrationPage';
import TeamMergeTool from './pages/admin/TeamMergeTool';
import OrgTeamsPage from './pages/admin-dashboard/OrgTeamsPage';
import PlayerClaimPage from './pages/claim/PlayerClaimPage';
import { RequireAdminRole } from './components/RequireAdminRole';
import { RequireTenantAdminRole } from './components/RequireTenantAdminRole';
import { RoleProvider } from './contexts/RoleContext';
import AcceptAdminInvitePage from './pages/invites/AcceptAdminInvitePage';
import AdminInvitationsPage from './pages/admin/AdminInvitationsPage';
import TenantInvitationsPage from './pages/manage/TenantInvitationsPage';
import ManageDashboardPage from './pages/manage/ManageDashboardPage';
import TenantDashboardPage from './pages/manage/TenantDashboardPage';
import MyEventsPage from './pages/modules/MyEventsPage';
import TrainingFeedPage from './pages/TrainingFeedPage';
import PublicFafsaHelper from './pages/public/PublicFafsaHelper';
import HighSchoolStandings from './pages/public/HighSchoolStandings';
import YouthStandings from './pages/public/YouthStandings';
import ProfilePreferences from './pages/ProfilePreferences';
import GmailCallbackPage from './pages/gmail-callback';
import TestStripe from './pages/TestStripe';
import MembershipSuccess from './pages/MembershipSuccess';
import { PacketPurchaseSuccess } from './pages/PacketPurchaseSuccess';
import BillingManagement from './pages/BillingManagement';
import EventManager from './pages/EventManager';
import AdminOrganizations from './pages/AdminOrganizations';
import AdminOrganizationDetail from './pages/AdminOrganizationDetail';
import OrgAdminDashboard from './pages/OrgAdminDashboard';
import OrgAdminEventDetails from './pages/OrgAdminEventDetails';
import OrgBrandingSettings from './pages/OrgBrandingSettings';
import CoachRecommendationResponse from './pages/coach-recommendation/response';
import CoachRegistrationConfirmation from './pages/CoachRegistrationConfirmation';
import EventMediaCredentialsPage from './pages/EventMediaCredentialsPage';

import CommunicationSubscribersManagement from './pages/admin-dashboard/CommunicationSubscribersManagement';
import AdvertisingManagement from './pages/admin-dashboard/AdvertisingManagement';
import IssueTracker from './pages/admin-dashboard/IssueTracker';

import SportHubPage from './pages/SportHubPage';
import DynamicPage from './pages/DynamicPage';
import ScoutManagement from './pages/admin-dashboard/ScoutManagement';
import VideoVendorManagement from './pages/admin-dashboard/VideoVendorManagement';
import GraphicsVendorManagement from './pages/admin-dashboard/GraphicsVendorManagement';
import EditorsManagement from './pages/admin-dashboard/EditorsManagement';
import EventFinancePage from './pages/admin/EventFinancePage';
import ClaimCoachProfile from './pages/ClaimCoachProfile';
import AcceptCoachInvitation from './pages/AcceptCoachInvitation';
import TournamentManagementPage from './pages/admin/TournamentManagementPage';
import RLHoopsPointEntry from './components/admin/rlhoops/RLHoopsPointEntry';
import PressDashboardLayout from './layouts/PressDashboardLayout';
import PressDashboardHome from './pages/press-dashboard/index';
import PressProfile from './pages/press-dashboard/profile';
import PressSettings from './pages/press-dashboard/settings';
import PressW9Page from './pages/press-dashboard/w9';

// Import video press dashboard components
import VideoPressLayout from './layouts/VideoPressLayout';
import VideoPressHome from './pages/video-press-dashboard/index';
import HoopsRecapsPage from './pages/video-press-dashboard/hoops-recaps';
import { Navigate, useParams } from 'react-router-dom';

/** The retired /scheduling/overview page — send anyone holding the link to the grid. */
function NavigateToGrid() {
  const { eventId } = useParams<{ eventId: string }>();
  return <Navigate to={`/admin-dashboard/events/${eventId}/scheduling/grid`} replace />;
}
import MagicImpersonationCallback from './pages/MagicImpersonationCallback';
import CommunicationProcessor from './components/admin/CommunicationProcessor';
import { AdminImpersonationProvider } from './contexts/AdminImpersonationContext';
import AdminImpersonationBanner from './components/admin/AdminImpersonationBanner';
import { OrganizationProvider } from './contexts/OrganizationContext';
import { OrgModulesProvider } from './contexts/OrgModulesContext';
import ModuleGuard from './components/common/ModuleGuard';
import ModulesSettings from './pages/admin/ModulesSettings';
import EventRegistrationSuccessV2 from './pages/EventRegistrationSuccessV2';

// Import multi-tenant test (available in console as testMultiTenantIsolation())
import '@/tests/multi-tenant-test';

// Event Management pages
import EventManagementOverview from './pages/admin/event-management/EventManagementOverview';
import EventManagementInventory from './pages/admin/event-management/EventManagementInventory';
import EventManagementStaffing from './pages/admin/event-management/EventManagementStaffing';
import EventManagementTravel from './pages/admin/event-management/EventManagementTravel';
import EventManagementOfficials from './pages/admin/event-management/EventManagementOfficials';
import EventManagementScorekeepers from './pages/admin/event-management/EventManagementScorekeepers';
import EventManagementChecklists from './pages/admin/event-management/EventManagementChecklists';
import EventManagementExpenses from './pages/admin/event-management/EventManagementExpenses';

import AdminLayout from './layouts/AdminLayout';
import AdminDashboardLayout from './layouts/AdminDashboardLayout';
import AdminAreaLayout from './layouts/AdminAreaLayout';
import VendorDashboardLayout from './components/vendor/VendorDashboardLayout';

// Import Customer Dashboard + Signup
import CustomerLayout from "@/layouts/CustomerLayout";
import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import CustomerOrdersPage from "@/pages/customer/CustomerOrdersPage";
import CustomerMyTicketsPage from "@/pages/customer/MyTicketsPage";
// CustomerSignupPage removed — invitation-only



// Import scout dashboard layout and pages
import ScoutDashboardLayout from '@/layouts/ScoutDashboardLayout';
import ScoutDashboardHome from './pages/scout-dashboard/index';
import ScoutAthletes from './pages/scout-dashboard/athletes';
import ScoutTasks from './pages/scout-dashboard/tasks';
import ScoutNotes from './pages/scout-dashboard/notes';
import ScoutLists from './pages/scout-dashboard/lists';
import ScoutCalendar from './pages/scout-dashboard/calendar';
import ScoutCoupons from './pages/scout-dashboard/coupons';
import ScoutW9Page from './pages/scout-dashboard/w9';

// Import module components that will be used in athlete dashboard routes
import ProfileBoost from './pages/modules/ProfileBoost';
import QrFlyer from './pages/modules/QrFlyer';
import QrFlyerPrint from './pages/QrFlyerPrint';
import CollegeSearch from './pages/modules/CollegeSearch';
import CollegeMapPage from './pages/CollegeMapPage';
import RecruitingTracker from './pages/modules/RecruitingTracker';
import EmailTools from './pages/modules/EmailTools';
import RecruitingTimeline from './pages/modules/RecruitingTimeline';
import CoreCourses from './pages/modules/CoreCourses';
import Scholarships from './pages/modules/Scholarships';
import SocialWall from './pages/modules/SocialWall';
import HashtagFeed from './pages/modules/HashtagFeed';
import DiscoverAthletes from './pages/modules/DiscoverAthletes';
import SharedPostPage from './pages/public/SharedPostPage';
import CommunityGuidelinesPage from './apps/social/pages/CommunityGuidelinesPage';

import AthleteProfile from './pages/modules/AthleteProfile';
import AthleteGraphics from './pages/modules/AthleteGraphics';
import CollegeCamps from './pages/modules/CollegeCamps';
import SavedCamps from './pages/modules/SavedCamps';

// Import graphics order fulfillment components
import VendorReview from './pages/athlete-dashboard/VendorReview';
import OrderGraphics from './pages/OrderGraphics';

import DiscountLocker from './pages/modules/DiscountLocker';
import CommitmentGraphicsModule from './components/commitment/CommitmentGraphicsModule';
import Connections from './pages/modules/Connections';
import AthleteAlerts from './pages/modules/AthleteAlerts';
import AthleteNotifications from './pages/modules/AthleteNotifications';

// Import admin dashboard pages
import AdminDashboardHome from './pages/admin-dashboard/AdminDashboardHome';
import AdminDashboardHub from './pages/admin-dashboard/AdminDashboardHub';
import TestNotificationsPage from './pages/admin/TestNotificationsPage';
import UsersManagement from './pages/admin-dashboard/UsersManagement';
import ClaimAccount from './pages/ClaimAccount';
import Account from './pages/Account';
import EventsManagement from './pages/admin-dashboard/EventsManagement';
import RecordsManagement from './pages/admin-dashboard/RecordsManagement';
import PhotosPlaceholder from './pages/admin-dashboard/PhotosPlaceholder';
import CoachPacketsPlaceholder from './pages/admin-dashboard/CoachPacketsPlaceholder';
import ResourcesPlaceholder from './pages/admin-dashboard/ResourcesPlaceholder';
import AdminHotelPartnersPage from './pages/admin-dashboard/hotel-partners/AdminHotelPartnersPage';
import HotelPortalLayout from './layouts/HotelPortalLayout';
import HotelPortalDashboard from './pages/hotel-portal/HotelDashboard';
import HotelPortalEvents from './pages/hotel-portal/HotelEvents';
import HotelPortalTracker from './pages/hotel-portal/HotelTracker';
import HotelPortalEventTracker from './pages/hotel-portal/EventTeamTracker';
import HotelPortalHotels from './pages/hotel-portal/HotelHotels';
import HotelPortalPropertiesManager from './pages/hotel-portal/HotelPropertiesManager';
import HotelPortalOutreach from './pages/hotel-portal/HotelOutreach';
import HotelPortalUpload from './pages/hotel-portal/HotelUpload';
import HotelPortalReports from './pages/hotel-portal/HotelReports';
import EventEditPage from './pages/admin-dashboard/EventEditPage';
import EventTeamsPage from './pages/admin-dashboard/EventTeamsPage';
import EventSchedulingRequestsPage from './pages/admin-dashboard/EventSchedulingRequestsPage';
import EventMessagesPage from './pages/admin-dashboard/EventMessagesPage';
import EventCredentialsCoachesPage from './pages/admin-dashboard/EventCredentialsCoachesPage';
import NotificationsPage from './pages/admin/NotificationsPage';
import EventTypesManagement from './pages/admin-dashboard/EventTypesManagement';
import EventCategoriesManagement from './pages/admin-dashboard/EventCategoriesManagement';
import CommunicationHubManagement from './pages/admin-dashboard/CommunicationHubManagement';
import RegistrationCommunicationsPage from './pages/admin-dashboard/RegistrationCommunicationsPage';
import CommunicationTemplatesManagement from './pages/admin-dashboard/CommunicationTemplatesManagement';
import EmailHeadersFooters from './pages/admin-dashboard/EmailHeadersFooters';
import CommunicationTriggersManagement from './pages/admin-dashboard/CommunicationTriggersManagement';
import TemplateCleanup from './pages/admin-dashboard/TemplateCleanup';
import CommunicationAnalyticsManagement from './pages/admin-dashboard/CommunicationAnalyticsManagement';
import CommunicationIntegrationsManagement from './pages/admin-dashboard/CommunicationIntegrationsManagement';
import SocialMediaManagementPage from './pages/admin-dashboard/SocialMediaManagement';
import SalesFunnelsManagement from './pages/admin-dashboard/SalesFunnelsManagement';
import AdminSettings from './pages/admin-dashboard/AdminSettings';
import AdminRolesManagement from '@/pages/admin-dashboard/AdminRolesManagement';
import NewsletterSchedules from './pages/admin/NewsletterSchedules';
import MikesDashboard from './pages/admin/MikesDashboard';
import ProfileFeaturesManagement from './pages/admin-dashboard/ProfileFeaturesManagement';
import AffiliateManagement from './pages/admin-dashboard/AffiliateManagement';
import MayEventAdmin from './pages/admin-dashboard/MayEventAdmin';
import AdminSalesOverview from './pages/admin-dashboard/AdminSalesOverview';
import LogsPage from './pages/admin-dashboard/LogsPage';
import VenueManagement from './pages/admin-dashboard/VenueManagement';
import StaffManagementPage from './pages/admin-dashboard/StaffManagementPage';
import StaffAdminPage from './pages/admin/StaffAdminPage';

import SportCoverPhotosPage from './pages/admin-dashboard/SportCoverPhotosPage';
import AdAssetsPage from './pages/admin-dashboard/AdAssetsPage';
import AdPerformancePage from './pages/admin-dashboard/AdPerformancePage';
import MessageTemplatesPage from './pages/admin-dashboard/MessageTemplatesPage';
import MessageTemplateEditPage from './pages/admin-dashboard/MessageTemplateEditPage';
import OrgEmailTemplatesPage from './pages/admin-dashboard/communication/OrgEmailTemplatesPage';
import OrgEmailTemplateEditPage from './pages/admin-dashboard/communication/OrgEmailTemplateEditPage';
import OrgEmailBrandingPage from './pages/admin-dashboard/communication/OrgEmailBrandingPage';
import RegistrationDashboardPage from './pages/admin-dashboard/RegistrationDashboardPage';
import LiveSheetsHub from './pages/admin-dashboard/LiveSheetsHub';
import SharedLiveSheetPage from './pages/events/SharedLiveSheetPage';
import EventSheetWindowPage from './pages/admin-dashboard/EventSheetWindowPage';
import AllEventsSheetPage from './pages/admin-dashboard/AllEventsSheetPage';
import EventSheetPage from './pages/EventSheetPage';
import PaymentSheetPage from './pages/live-sheets/PaymentSheetPage';
import RosterSheetPage from './pages/live-sheets/RosterSheetPage';
import MySheetsPage from './pages/live-sheets/MySheetsPage';
import PlayersSheetPage from './pages/live-sheets/PlayersSheetPage';
import CheckinSheetPage from './pages/live-sheets/CheckinSheetPage';
import CircuitSheetPage from './pages/live-sheets/CircuitSheetPage';
import EventSummarySheetPage from './pages/live-sheets/EventSummarySheetPage';
import AdminLiveSheetsPage from './pages/admin/AdminLiveSheetsPage';
import EventDiscountPoliciesManagement from './pages/admin-dashboard/EventDiscountPoliciesManagement';
import DivisionsCatalogPage from './design-system/pages/DivisionsCatalogPage';
import CouponsPage from './design-system/pages/CouponsPage';
import MasterTeamsPage from './design-system/pages/MasterTeamsPage';
import ConstraintsCatalogPage from './design-system/pages/ConstraintsCatalogPage';
import FaqCatalogPage from './design-system/pages/FaqCatalogPage';
import WaiverCatalogPage from './design-system/pages/WaiverCatalogPage';
import ExtrasCatalogPage from './design-system/pages/ExtrasCatalogPage';
import HotelPartnerDashboard from './design-system/pages/HotelPartnerDashboard';
import EventCouponsManagement from './pages/admin-dashboard/EventCouponsManagement';
import EventSponsorsManagement from './pages/admin-dashboard/EventSponsorsManagement';
import RegistrationFormsPage from './pages/admin-dashboard/RegistrationFormsPage';
import EventSpecialRequestsView from './components/admin-dashboard/EventSpecialRequestsView';
import LeaderboardsManagement from './pages/admin-dashboard/LeaderboardsManagement';
import LeaderboardBuilder from './pages/admin-dashboard/LeaderboardBuilder';
import LeaderboardEntries from './pages/admin-dashboard/LeaderboardEntries';
import SportsHubsManagementPage from './pages/admin-dashboard/SportsHubsManagement';
import SportsHubMessagesManagementPage from './pages/admin-dashboard/SportsHubMessagesManagementPage';
import StaffManagement from './pages/admin/StaffManagement';

// Import vendor press dashboard pages
import VendorPressDashboardIndex from './pages/vendor-press-dashboard/index';
import VendorPressSettings from './pages/vendor-press-dashboard/settings';

// Import vendor video dashboard
import VendorVideoDashboardLayout from './layouts/VendorVideoDashboardLayout';
import VendorVideoDashboard from './pages/vendor-video-dashboard/VendorVideoDashboard';
import VendorProfile from './pages/vendor-video-dashboard/VendorProfile';
import VendorPortfolio from './pages/vendor-video-dashboard/VendorPortfolio';

// Import vendor graphics dashboard
import VendorGraphicsDashboardLayout from './layouts/VendorGraphicsDashboardLayout';
import VendorGraphicsDashboard from './pages/vendor-graphics-dashboard/VendorGraphicsDashboard';
import VendorGraphicsProfile from './pages/vendor-graphics-dashboard/VendorProfile';
import VendorGraphicsPortfolio from './pages/vendor-graphics-dashboard/VendorPortfolio';
import VendorGraphicsPackages from './pages/vendor-graphics-dashboard/VendorPackages';
import VendorGraphicsOrders from './pages/vendor-graphics-dashboard/VendorOrders';
import VendorGraphicsOrderDetail from './pages/vendor-graphics-dashboard/VendorOrderDetail';
import VendorGraphicsMessages from './pages/vendor-graphics-dashboard/VendorMessages';
import VendorGraphicsFinance from './pages/vendor-graphics-dashboard/VendorFinance';
import VendorGraphicsReviews from './pages/vendor-graphics-dashboard/VendorReviews';
import VendorGraphicsW9Page from './pages/vendor-graphics-dashboard/W9';
import VendorPackages from './pages/vendor-video-dashboard/VendorPackages';
import VendorEvents from './pages/vendor-video-dashboard/VendorEvents';
import VendorMessages from './pages/vendor-video-dashboard/Messages';
import VendorSettings from './pages/vendor-video-dashboard/VendorSettings';
import { VideoDownload } from './pages/VideoDownload';
import VideoPaymentSuccess from './pages/VideoPaymentSuccess';
import VideoPaymentCanceled from './pages/VideoPaymentCanceled';

//Imports for parent pages
import ParentViewAthlete from './pages/ParentViewAthlete';
import ParentAthleteImpersonation from './pages/parent/ParentAthleteImpersonation';
import ParentAthleteView from "./pages/ParentAthleteView";
import MyRegistrations from './pages/parent/MyRegistrations';
import ParentVideoOrders from './pages/parent/ParentVideoOrders';
import AllOrdersPage from './pages/parent/AllOrdersPage';
import AthleteConnections from './pages/parent-dashboard/athlete-connections';
import ParentPressMemberships from './pages/parent/ParentPressMemberships';


// Import new pages for membership and settings
import AthleteMembership from './pages/modules/AthleteMembership';

// Import public pages
import About from './pages/About';
import Contact from './pages/Contact';
import Commitments from './pages/Commitments';
import { Testimonials } from './pages/Testimonials';
import SportsHubsIndex from './pages/SportsHubsIndex';

// Import affiliate components
import AffiliateDashboardLayout from './layouts/AffiliateDashboardLayout';
import AffiliateDashboard from './pages/affiliate/AffiliateDashboard';
import Payouts from './pages/affiliate/Payouts';
import AffiliateCouponCodes from './pages/affiliate/AffiliateCouponCodes';
import AffiliateAnalytics from './pages/affiliate/AffiliateAnalytics';
import AffiliateW9Page from './pages/affiliate/W9';
import MarketingMaterials from './pages/affiliate/MarketingMaterials';
import AffiliateTracker from './components/AffiliateTracker';

// Import sales dashboard components
import SalesDashboardLayout from './layouts/SalesDashboardLayout';
import SalesDashboard from './pages/sales-dashboard/index';
import SalesPipeline from './pages/sales-dashboard/pipeline';
import AffiliatesPage from './pages/sales-dashboard/affiliates';
import WhiteLabelPage from './pages/sales-dashboard/white-label';
import TeamsPage from './pages/sales-dashboard/teams';
import AdvertisersPage from './pages/sales-dashboard/advertisers';
import PartnersPage from './pages/sales-dashboard/partners';
import CollegeCoachesPage from './pages/sales-dashboard/college-coaches';
import SalesAnalyticsPage from './pages/sales-dashboard/analytics';
import SalesToolsPage from './pages/sales-dashboard/tools';

// Import staff dashboard components
import StaffDashboardLayout from './layouts/StaffDashboardLayout';
import StaffLayout from './layouts/StaffLayout';
import StaffDashboard from './pages/staff/StaffDashboard';
import StaffHomeLayout from './layouts/StaffHomeLayout';
import StaffHome from './pages/staff/StaffHome';

// Import editor dashboard components
import EditorDashboardLayout from './layouts/EditorDashboardLayout';
import EditorDashboard from './pages/editor/EditorDashboard';
import EditorCamps from './pages/editor/EditorCamps';
import EditorNcaaCalendar from './pages/editor/EditorNcaaCalendar';

//Import event components
import CreateEventPage from './pages/admin-dashboard/CreateEventPage';
import EventFAQsPage from "./pages/admin-dashboard/events/EventFAQsPage";
import CircuitsManagement from "./pages/admin-dashboard/CircuitsManagement";
import CircuitDetailPage from "./pages/admin-dashboard/CircuitDetailPage";
import PublicCircuitsIndex from "./pages/public/CircuitsIndexPage";
import PublicCircuitStandings from "./pages/public/CircuitStandingsPage";
import EventRegistration from "@/pages/event_registration";

// Design system preview pages (from Builder.io)
import RLEventsDashboard from '@/design-system/preview/RLevents-Dashboard';
import RLEventsTournaments from '@/design-system/preview/RLevents-Tournaments';
import RLEventsCreateEvent from '@/design-system/preview/RLevents-CreateEvent';
import RLEventsEventEditor from '@/design-system/preview/RLevents-EventEditor';
import RLEventsFlowBuilder from '@/design-system/preview/RLevents-FlowBuilder';

// Design system production pages (wired to real data)
import RLeventsTournamentsPage from '@/design-system/pages/RLeventsTournamentsPage';
import RLeventsCreateEventPage from '@/design-system/pages/RLeventsCreateEventPage';
import RLeventsEventEditorPage from '@/design-system/pages/RLeventsEventEditorPage';
import EventRegistrationSuccessPage from "@/pages/event-registration-success";
import EventRosterManagementPage from '@/pages/club-coach/EventRosterManagementPage';
import RedirectToNewRegistration from '@/components/RedirectToNewRegistration';
import RegistrationCart from '@/pages/public/RegistrationCart';
import RegistrationSuccess from '@/pages/public/RegistrationSuccess';
import CoachInviteAccept from '@/pages/public/CoachInviteAccept';
import MyRegistrationsDashboard from '@/pages/public/MyRegistrationsDashboard';
import PacketManagementPage from '@/pages/admin/PacketManagementPage';
import EventAnalyticsDashboard from '@/components/admin/EventAnalyticsDashboard';

// Import tournament pages
import TournamentDiscoveryPage from '@/pages/TournamentDiscoveryPage';
import TournamentDetailPage from '@/pages/TournamentDetailPage';
import TournamentBracketPage from '@/pages/TournamentBracketPage';
import TournamentSchedulePage from '@/pages/TournamentSchedulePage';
import PublicLeaderboard from '@/pages/public/PublicLeaderboard';
import StaffCheckInPage from '@/pages/staff/StaffCheckInPage';
import StaffCheckinSheetPage from '@/pages/staff/StaffCheckinSheetPage';
import StaffLiveSheetsPage from '@/pages/staff/StaffLiveSheetsPage';
import StaffRegistrations from '@/pages/staff/StaffRegistrations';
import StaffEditRegistrations from '@/pages/staff/StaffEditRegistrations';
import StaffManageEvent from '@/pages/staff/StaffManageEvent';
import StaffViewReports from '@/pages/staff/StaffViewReports';
import StaffTournamentPage from '@/pages/staff/StaffTournamentPage';
import StaffEventCheckInPage from '@/pages/staff/StaffEventCheckInPage';
import StaffTournamentsRedirect from '@/pages/staff/StaffTournamentsRedirect';





//Import Club Coach Components
import ClubCoachEventsPage from "@/pages/club-coach/ClubCoachEventsPage";
import ClubCoachTeamsPage from "@/pages/club-coach/ClubCoachTeamsPage";
import MyRostersPage from "@/pages/club-coach/MyRostersPage";
import SchedulingRequestNewPage from "@/pages/club-coach/SchedulingRequestNewPage";
import TeamPrintPage from "@/pages/club-coach/TeamPrintPage";
import ExtrasMarketplace from "@/pages/ExtrasMarketplace";
import ProfileSetup from '@/pages/ProfileSetup';
import MyPacketsPage from './pages/club-coach/MyPacketsPage';
import PublicTeamPage from './pages/public/PublicTeamPage';
import JoinTeam from './pages/JoinTeam';
import JoinTeamComplete from './pages/JoinTeamComplete';
import EventsHubPage from './pages/EventsHub/EventsHubPage';
// Coach dashboards live on RecruitLook — old RLevents coach URLs hand over.
import RedirectToRecruitLook, { ProfileRedirect } from './pages/RedirectToRecruitLook';
import NotFound from './pages/NotFound';
import OperatorEventOverviewPage from './pages/Console/OperatorEventOverviewPage';
import OperatorEventRegistrationsPage from './pages/Console/OperatorEventRegistrationsPage';
import OperatorEventConflictAnalyzerPage from './pages/Console/OperatorEventConflictAnalyzerPage';
import OperatorEventScheduleSetupPage from './pages/admin/OperatorEventScheduleSetupPage';
import OperatorEventVenuesCourtsPage from './pages/admin/OperatorEventVenuesCourtsPage';
import OperatorEventOfficialsPage from './pages/admin/OperatorEventOfficialsPage';
import OperatorEventOfficialsHubPage from './pages/admin/OperatorEventOfficialsHubPage';
import OperatorEventVerificationPage from './pages/admin/OperatorEventVerificationPage';
import OperatorEventHotelsPage from './pages/admin/OperatorEventHotelsPage';
import OperatorEventOpsPage from './pages/admin/OperatorEventOpsPage';


import OperatorEventScheduleDraftPage from './pages/admin/OperatorEventScheduleDraftPage';
import OperatorEventSchedulingStartPage from './pages/admin/OperatorEventSchedulingStartPage';
import OperatorEventBracketsPage from './pages/admin/OperatorEventBracketsPage';
import OperatorEventPoolsPage from './pages/admin/OperatorEventPoolsPage';
import OperatorEventTeamSummaryPage from './pages/admin/OperatorEventTeamSummaryPage';
import EventDivisionsLayout from './pages/admin/divisions/EventDivisionsLayout';
import {
  DivisionDetailsScreen, DivisionTeamsScreen, DivisionPoolsScreen, DivisionPoolsAssignScreen, DivisionPoolRoundRobinScreen, DivisionPoolPrintScreen, DivisionPoolGamesScreen,
  DivisionBracketGamesScreen, DivisionBracketScreen, DivisionRestrictionsScreen, DivisionPlacesScreen,
} from './pages/admin/divisions/screens';
import { RouteErrorBoundary } from './components/RouteErrorBoundary';
import OperatorPostScoresPage from './pages/admin/OperatorPostScoresPage';
import ScheduleReviewRedirect from './pages/admin/ScheduleReviewRedirect';
import OperatorEventPrintPackPage from './pages/admin/OperatorEventPrintPackPage';

function App() {
  // Initialize Google Analytics page tracking
  usePageTracking();
  
  console.log("🚀 App component rendered, checking routes");
  console.log("📍 Current location:", window.location.pathname);
  
  return (
    <Routes>
      {/* CRITICAL: Password reset routes MUST be outside GlobalLayout to avoid auth context issues */}
      <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/style-guide" element={<StyleGuide />} />
      <Route path="/checkin/:token" element={<CheckinScanPage />} />
      {/* Share-link recipients: no site chrome at all. */}
      <Route path="/sheet/share/:token" element={<SharedLiveSheetPage />} />
      
      {/* All other routes go through GlobalLayout */}
      <Route path="*" element={
        <GlobalLayout>
          <OrganizationProvider>
            <OrgModulesProvider>
            <AdminImpersonationProvider>

            <RoleProvider>
            <AdminImpersonationBanner />
            {/* Affiliate tracking runs on every page */}
            <>{/* eslint-disable-next-line react/jsx-no-useless-fragment */}</>
            {/* Inject tracker component */}
            {/** Keep this at the top-level so it executes on all routes */}
            <AffiliateTracker />
            <Routes>
        {/* Main public routes - now use GlobalLayout which includes PublicHeader */}
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/videos" element={<VideoMarketplace />} />
        <Route path="/videos/hoops_recaps" element={<VideoHoopsRecaps />} />
        <Route path="/videos/hoops_recaps/watch" element={<VideoHoopsWatch />} />
        <Route path="/video-membership-purchase" element={<VideoMembershipPurchase />} />
        <Route path="/video-membership-success" element={<VideoMembershipSuccess />} />
        <Route path="/coaches" element={<Coaches />} />
        <Route path="/softball" element={<Softball />} />
        <Route path="/hoops" element={<Hoops />} />
        <Route path="/boys-circuit" element={<BoysCircuit />} />
        <Route path="/girls-circuit" element={<GirlsCircuit />} />
        <Route path="/larry-hughes-elite-camp" element={<LarryHughesEliteCamp />} />
        
        <Route path="/juniors-circuit" element={<JuniorsCircuit />} />
        <Route path="/scouts" element={<Scouts />} />
        <Route path="/about" element={<About />} />
        <Route path="/commitments" element={<Commitments />} />
        <Route path="/sports-hubs" element={<SportsHubsIndex />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/qr/checkin" element={<QrCheckInPage />} />
        <Route path="/schedule/:slug" element={<PublicSchedulePage />} />
        <Route path="/schedule/:slug/team/:teamId" element={<PublicEventTeamPage />} />
        <Route path="/scoreboard/:slug" element={<PublicScoreboardPage />} />
        <Route path="/standings/:slug" element={<PublicStandingsPage />} />
        <Route path="/brackets/:slug" element={<PublicBracketsPage />} />
        <Route path="/venues/:slug" element={<PublicVenuesPage />} />
        <Route path="/unsubscribe" element={<PublicUnsubscribePage />} />

        <Route path="/" element={<HomePage />} />
        <Route path="/event-manager" element={<EventManager />} />
        {/* Coach dashboard removed from RLevents — RecruitLook owns the coach's
            view of teams, rosters and players. Old URLs hand over instead of 404. */}
        <Route path="/club-dash/*" element={<RedirectToRecruitLook />} />
        {/* /dashboard resolves to whatever this account actually has in RLevents */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/account-not-set-up" element={<AccountNotSetUp />} />

        {/* Athlete directory/profile pages now live on RecruitLook */}
        <Route path="/athletes" element={<RedirectToRecruitLook href="https://recruitlook.com/athletes" />} />
        <Route path="/directory" element={<RedirectToRecruitLook href="https://recruitlook.com/athletes" />} />
        <Route path="/profile/:username" element={<ProfileRedirect />} />
        
        <Route path="/qr-flyer/print/:username" element={<QrFlyerPrint />} />
        
        
        {/* Social Wall shared post */}
        <Route path="/wall/post/:postId" element={<SharedPostPage />} />
        
        {/* NEW: Public Events routes */}
        <Route path="/events" element={<EventsPage />} />
        <Route path="/may-live-period-kc" element={<MayLivePeriodKC />} />
        <Route path="/events/:slug" element={<EventPage />} />
        <Route path="/event-extras" element={<EventExtrasPage />} />
        <Route path="/events/:eventId/player-extras" element={<EventExtrasPage />} />
        <Route path="/my-wallet" element={<MyDigitalWalletPage />} />
        <Route path="/purchase/receipt" element={<PurchaseReceiptPage />} />
        <Route path="/schedule-requests" element={<ScheduleRequestsPage />} />
        <Route path="/scheduling-response/:token" element={<SchedulingResponsePage />} />
        <Route path="/events/legacy/:slug" element={<EventDetailPage />} />
        <Route path="/events/:eventId/spectator-tickets" element={<SpectatorTicketPurchase />} />
        {/* Chrome-less Live Sheet window — opened per event via window.open. */}
        <Route path="/events/:eventId/sheet" element={<ProtectedRoute><EventSheetWindowPage /></ProtectedRoute>} />
        <Route path="/spectator-ticket-success" element={<SpectatorTicketSuccess />} />
        <Route path="/coach-registration-confirmation" element={<CoachRegistrationConfirmation />} />
        <Route path="/event-media-credentials" element={<EventMediaCredentialsPage />} />

        {/* Public Circuit pages */}
        <Route path="/circuits" element={<PublicCircuitsIndex />} />
        <Route path="/circuits/:slug" element={<PublicCircuitStandings />} />
        
        {/* OLD REGISTRATION ROUTES - Redirect to new system */}
        <Route path="/events/:slug/register" element={<RegistrationCart />} />
        <Route path="/events/:slug/register/success" element={<RegistrationSuccess />} />
        <Route path="/coach-invite/:token" element={<CoachInviteAccept />} />
        <Route path="/my-dashboard" element={<ProtectedRoute><MyRegistrationsDashboard /></ProtectedRoute>} />
        <Route path="/events/:slug/register-legacy" element={<RedirectToNewRegistration />} />
        <Route path="/event_registration" element={<Navigate to="/events" replace />} />
        
        <Route path="/event-registration-success" element={<EventRegistrationSuccessPage />} />
        <Route path="/event-registration-success-v2" element={<EventRegistrationSuccessV2 />} />
        <Route path="/club-coach-dashboard/events/:eventId/roster-management" element={<EventRosterManagementPage />} />

        {/* Live Sheets — public shareable token pages (no account needed) */}
        <Route path="/event-sheet/:token" element={<EventSheetPage />} />
        <Route path="/payment-sheet/:token" element={<PaymentSheetPage />} />
        <Route path="/roster-sheet/:token" element={<RosterSheetPage />} />
        <Route path="/players-sheet/:token" element={<PlayersSheetPage />} />
        <Route path="/checkin-sheet/:token" element={<CheckinSheetPage />} />
        <Route path="/staff/checkin-sheet" element={<ProtectedRoute><StaffCheckinSheetPage /></ProtectedRoute>} />
        <Route path="/circuit-sheet/:token" element={<CircuitSheetPage />} />
        <Route path="/event-summary/:token" element={<EventSummarySheetPage />} />
        <Route path="/my-sheets" element={<MySheetsPage />} />


        
        {import.meta.env.DEV && <Route path="/__grid-harness" element={<GridHarnessPage />} />}
        {/* Demo Routes - Standalone pages */}
        <Route path="/demo/login" element={<DemoProvider><DemoLoginPage /></DemoProvider>} />
        <Route path="/demo" element={<Navigate to="/demo/hub" replace />} />
        <Route path="/demo/hub" element={<DemoProvider><DemoHubPage /></DemoProvider>} />
        <Route path="/demo/events" element={<DemoEvents />} />
        <Route path="/demo/data" element={<DemoDataPage />} />
        
        {/* Demo Dashboard Routes - with Demo Layout Wrapper */}
        <Route path="/demo" element={<DemoLayout />}>
          <Route path="tournaments" element={<DemoTournaments />} />
          <Route path="event-management" element={<DemoEventManagementRedirect />} />
          <Route path="event-management/:eventId" element={<DemoEventManagement />} />
          <Route path="registrations" element={<DemoRegistrations />} />
          <Route path="check-in" element={<DemoCheckIn />} />
          <Route path="scoring" element={<DemoScoringRedirect />} />
          <Route path="scoring/:eventId" element={<DemoScoring />} />
          <Route path="packets" element={<DemoPackets />} />
          <Route path="packet-generator" element={<DemoPacketGenerator />} />
          <Route path="staffing" element={<DemoStaffing />} />
          <Route path="officials" element={<DemoOfficials />} />
          <Route path="scorekeepers" element={<DemoScorekeepers />} />
          <Route path="travel" element={<DemoTravel />} />
          <Route path="inventory" element={<DemoInventory />} />
          <Route path="checklists" element={<DemoChecklists />} />
          <Route path="leaderboards" element={<DemoLeaderboards />} />
          <Route path="scheduling" element={<DemoScheduling />} />
          <Route path="create-event" element={<DemoCreateEvent />} />
        </Route>
        
        {/* Public Leaderboard route */}
        <Route path="/leaderboard/:id" element={<PublicLeaderboard />} />
        
        {/* Public Team Page route */}
        <Route path="/team/:slug" element={<PublicTeamPage />} />
        
        {/* Protected Social Wall route - requires authentication */}
        <Route path="/wall" element={<ProtectedRoute><GlobalLayout><SocialWall /></GlobalLayout></ProtectedRoute>} />
        
        {/* Training Feed - requires authentication (athletes & coaches only) */}
        <Route path="/training" element={<GlobalLayout><TrainingFeedPage /></GlobalLayout>} />
        
        {/* Community Guidelines - Public */}
        <Route path="/community-guidelines" element={<CommunityGuidelinesPage />} />
        
        {/* NEW: Public Tournament routes */}
        <Route path="/tournaments" element={<TournamentDiscoveryPage />} />
        <Route path="/tournaments/:id" element={<TournamentDetailPage />} />
        <Route path="/tournaments/:id/bracket" element={<TournamentBracketPage />} />
        <Route path="/tournaments/:id/schedule" element={<TournamentSchedulePage />} />
    
        
        {/* Video Download Route */}
        <Route path="/video-download/:orderId" element={<VideoDownload />} />
        
        {/* Video Payment Routes */}
        <Route path="/video-payment-success" element={<VideoPaymentSuccess />} />
        <Route path="/video-payment-canceled" element={<VideoPaymentCanceled />} />
        
        {/* Coach Recommendation Response Route */}
        <Route path="/coach-recommendation/response" element={<CoachRecommendationResponse />} />
        
        {/* Claim Account Route - Public */}
        <Route path="/claim-account" element={<ClaimAccount />} />
        <Route path="/account" element={<Account />} />
        <Route path="/account/phone" element={<Account />} />
        
        {/* Join Team Routes - Public */}
        <Route path="/join-team" element={<JoinTeam />} />
        <Route path="/join-team-complete" element={<JoinTeamComplete />} />
        
        {/* Accept Coach Invitation Route - Public */}
        <Route path="/accept-coach-invitation" element={<AcceptCoachInvitation />} />
        
        {/* College Search & Map Routes - Public */}
        <Route path="/college-search" element={<CollegeSearch />} />
        <Route path="/college-map" element={<CollegeMapPage />} />
        
        {/* FAFSA Helper - Public */}
        <Route path="/fafsa-helper" element={<PublicFafsaHelper />} />
        
        {/* RLHoops Standings - Public */}
        <Route path="/standings/high-school" element={<HighSchoolStandings />} />
        <Route path="/standings-high-school" element={<HighSchoolStandings />} />
        <Route path="/standings/youth" element={<YouthStandings />} />
        <Route path="/standings-youth" element={<YouthStandings />} />
        
        {/* Mobile Events App - Standalone mobile app preview */}
        <Route path="/mobile-events" element={<MobileEventsApp />} />
        
        {/* Dynamic page routes - these should come after specific routes */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/media-policy" element={<MediaPolicy />} />
        <Route path="/pages/:slug" element={<DynamicPage />} />

        {/* Magic Link Impersonation Callback Route */}
        <Route path="/magic-impersonation-callback" element={<MagicImpersonationCallback />} />

        {/* Sport Hub Pages route */}
        <Route path="/sports-hubs/:sportSlug" element={<SportHubPage />} />

        {/* NEW: Parent view athlete route - secure tokenized access */}
        <Route path="/parent-view-athlete/:athleteId" element={<ParentViewAthlete />} />

        {/* Test Routes */}
        <Route path="/test-stripe" element={<ProtectedRoute><TestStripe /></ProtectedRoute>} />
        <Route path="/process-communications" element={<CommunicationProcessor />} />
        
        {/* Billing Management Route */}
        <Route path="/billing" element={<ProtectedRoute><BillingManagement /></ProtectedRoute>} />

        {/* Membership Success Route */}
        <Route path="/membership-success" element={<ProtectedRoute><MembershipSuccess /></ProtectedRoute>} />
        
        {/* Packet Purchase Success Route */}
        <Route path="/packet-purchase-success" element={<ProtectedRoute><PacketPurchaseSuccess /></ProtectedRoute>} />

        {/* /register removed — RLevents is invitation-only */}
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route path="/signup" element={<Navigate to="/login" replace />} />
        <Route path="/auth/register" element={<Navigate to="/login" replace />} />
        <Route path="/signup/customer" element={<Navigate to="/login" replace />} />

        {/* Press Dashboard Routes - NEW */}
        <Route path="/press-dashboard" element={<ProtectedRoute><PressDashboardLayout /></ProtectedRoute>}>
          <Route index element={<PressDashboardHome />} />
          <Route path="profile" element={<PressProfile />} />
          <Route path="w9" element={<PressW9Page />} />
          <Route path="settings" element={<PressSettings />} />
        </Route>

        {/* Video Press Dashboard Routes - NEW */}
        <Route path="/video-press-dashboard" element={<ProtectedRoute><VideoPressLayout /></ProtectedRoute>}>
          <Route index element={<VideoPressHome />} />
          <Route path="hoops-recaps" element={<HoopsRecapsPage />} />
          <Route path="videos" element={<HoopsRecapsPage />} />
          <Route path="profile" element={<PressProfile />} />
          <Route path="settings" element={<PressSettings />} />
        </Route>
        {/* Route Customer Dashboard */}
<Route path="/customer-dashboard" element={<CustomerLayout />}>
  <Route index element={<CustomerDashboard />} />
  <Route path="orders" element={<CustomerOrdersPage />} />
  <Route path="my-tickets" element={<CustomerMyTicketsPage />} />
</Route>


         {/* /signup/customer redirected above to /login */}


        {/* Scout Dashboard Routes */}
        <Route path="/scout-dashboard" element={<ProtectedRoute><ScoutDashboardLayout /></ProtectedRoute>}>
          <Route index element={<ScoutDashboardHome />} />
          <Route path="athletes" element={<ScoutAthletes />} />
          <Route path="tasks" element={<ScoutTasks />} />
          <Route path="notes" element={<ScoutNotes />} />
          <Route path="lists" element={<ScoutLists />} />
          <Route path="calendar" element={<ScoutCalendar />} />
          <Route path="coupons" element={<ScoutCoupons />} />
          <Route path="w9" element={<ScoutW9Page />} />
        </Route>

        {/* Affiliate Dashboard Routes - NEW */}
        <Route path="/affiliate-dashboard" element={<ProtectedRoute><AffiliateDashboardLayout /></ProtectedRoute>}>
          <Route index element={<AffiliateDashboard />} />
          <Route path="analytics" element={<AffiliateAnalytics />} />
          <Route path="coupons" element={<AffiliateCouponCodes />} />
          <Route path="marketing" element={<MarketingMaterials />} />
          <Route path="payouts" element={<Payouts />} />
          <Route path="w9" element={<AffiliateW9Page />} />
        </Route>

        {/* Sales Dashboard Routes - NEW */}
        <Route path="/sales-dashboard" element={<ProtectedRoute><SalesDashboardLayout /></ProtectedRoute>}>
          <Route index element={<SalesDashboard />} />
          <Route path="pipeline" element={<SalesPipeline />} />
          <Route path="affiliates" element={<AffiliatesPage />} />
          <Route path="white-label" element={<WhiteLabelPage />} />
          <Route path="teams" element={<TeamsPage />} />
          <Route path="advertisers" element={<AdvertisersPage />} />
          <Route path="partners" element={<PartnersPage />} />
          <Route path="college-coaches" element={<CollegeCoachesPage />} />
          <Route path="analytics" element={<SalesAnalyticsPage />} />
          <Route path="tools" element={<SalesToolsPage />} />
        </Route>

        {/* Staff Dashboard Routes - NEW */}
        <Route path="/staff-dashboard" element={<ProtectedRoute><StaffLayout /></ProtectedRoute>}>
          <Route index element={<StaffDashboard />} />
        </Route>

        {/* Hotel Partner Portal */}
        <Route path="/hotel-portal" element={<ProtectedRoute><HotelPortalLayout /></ProtectedRoute>}>
          <Route index element={<HotelPortalDashboard />} />
          <Route path="events" element={<HotelPortalEvents />} />
          <Route path="tracker" element={<HotelPortalTracker />} />
          <Route path="events/:eventId" element={<HotelPortalEventTracker />} />
          <Route path="hotels" element={<HotelPortalHotels />} />
          <Route path="hotels/:eventId" element={<HotelPortalPropertiesManager />} />
          <Route path="outreach" element={<HotelPortalOutreach />} />
          <Route path="upload" element={<HotelPortalUpload />} />
          <Route path="reports" element={<HotelPortalReports />} />
        </Route>

        {/* Editor Dashboard Routes */}
        <Route path="/editor-dashboard" element={<Navigate to="/editor" replace />} />
        <Route path="/editor" element={<ProtectedRoute><EditorDashboardLayout /></ProtectedRoute>}>
          <Route index element={<EditorDashboard />} />
          <Route path="camps" element={<EditorCamps />} />
          <Route path="ncaa-calendar" element={<EditorNcaaCalendar />} />
        </Route>

        {/* Athlete, parent and coach dashboards were removed from RLevents.
            RecruitLook owns those audiences — old URLs hand over or explain
            rather than 404. */}
        <Route path="/athlete-dashboard/*" element={<RedirectToRecruitLook next="/athlete-dashboard" />} />
        <Route path="/athlete/*" element={<RedirectToRecruitLook next="/athlete-dashboard" />} />

        <Route path="/teams/new" element={<NewTeamPage />} />
        <Route path="/teams/:slug" element={<TeamDetailPage />} />
        <Route path="/invites/team/:token" element={<AcceptTeamInvitePage />} />
        <Route path="/pay/:teamId" element={<TeamBillingPublicPage />} />
        <Route path="/claim/player/:token" element={<PlayerClaimPage />} />
        <Route path="/events/:eventSlug/register" element={<ProtectedRoute><EventRegistrationPage /></ProtectedRoute>} />
        <Route path="/admin/teams/merge" element={<RequireAdminRole><TeamMergeTool /></RequireAdminRole>} />
        <Route path="/admin/invitations" element={<RequireAdminRole><AdminInvitationsPage /></RequireAdminRole>} />

        <Route path="/invites/admin/:token" element={<AcceptAdminInvitePage />} />
        <Route path="/manage/dashboard" element={<Navigate to="/admin-dashboard" replace />} />
        <Route path="/manage/events" element={<Navigate to="/admin-dashboard/events" replace />} />
        <Route path="/manage/invitations" element={<RequireTenantAdminRole><TenantInvitationsPage /></RequireTenantAdminRole>} />

        {/* Coach routes now live on RecruitLook */}
        <Route path="/club-coach-dashboard/*" element={<RedirectToRecruitLook />} />
        <Route path="/college-coach-dashboard/*" element={<RedirectToRecruitLook next="/college-coach-dashboard" />} />
        <Route path="/college-coach/*" element={<RedirectToRecruitLook next="/college-coach-dashboard" />} />
        <Route path="/coach-dashboard" element={<RedirectToRecruitLook />} />
        <Route path="/events-hub" element={<ProtectedRoute><EventsHubPage /></ProtectedRoute>} />
        <Route path="/dashboard/*" element={<RedirectToRecruitLook />} />

        {/* Parent dashboard removed */}
        <Route path="/parent-dashboard/*" element={<Navigate to="/account-not-set-up" replace />} />

        {/* Vendor-Press-Dashboard routes - MAIN VENDOR DASHBOARD */}
        <Route path="/vendor-press-dashboard" element={
          <ProtectedRoute>
            <VendorDashboardLayout />
          </ProtectedRoute>
        }>
          <Route index element={<VendorPressDashboardIndex />} />
          <Route path="w9" element={<PressW9Page />} />
          <Route path="settings" element={<VendorPressSettings />} />
        </Route>

        {/* Vendor Video Dashboard Routes - NEW */}
        <Route path="/vendor-video-dashboard" element={<ProtectedRoute><VendorVideoDashboardLayout /></ProtectedRoute>}>
          <Route index element={<VendorVideoDashboard />} />
          <Route path="profile" element={<VendorProfile />} />
          <Route path="portfolio" element={<VendorPortfolio />} />
          <Route path="packages" element={<VendorPackages />} />
          <Route path="events" element={<VendorEvents />} />
          <Route path="messages" element={<VendorMessages />} />
          <Route path="settings" element={<VendorSettings />} />
        </Route>

        {/* Vendor Graphics Dashboard Routes - NEW */}
        <Route path="/vendor-graphics-dashboard" element={<ProtectedRoute><VendorGraphicsDashboardLayout /></ProtectedRoute>}>
          <Route index element={<VendorGraphicsDashboard />} />
          <Route path="profile" element={<VendorGraphicsProfile />} />
          <Route path="portfolio" element={<VendorGraphicsPortfolio />} />
          <Route path="packages" element={<VendorGraphicsPackages />} />
          <Route path="orders" element={<VendorGraphicsOrders />} />
          <Route path="orders/:orderId" element={<VendorGraphicsOrderDetail />} />
          <Route path="messages" element={<VendorGraphicsMessages />} />
          <Route path="reviews" element={<VendorGraphicsReviews />} />
          <Route path="finance" element={<VendorGraphicsFinance />} />
          <Route path="w9" element={<VendorGraphicsW9Page />} />
        </Route>

        {/* Redirect old vendor-dashboard routes to new vendor-press-dashboard routes */}
        <Route path="/vendor-dashboard/*" element={<Navigate to="/vendor-press-dashboard" replace />} />

        {/* Org Admin Dashboard Routes */}
        <Route path="/org-admin-dashboard" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route index element={<OrgAdminDashboard />} />
          <Route path="branding" element={<OrgBrandingSettings />} />
        </Route>

        {/* Org Admin Event Management Routes */}
        <Route path="/org-admin" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route path="events/:eventId" element={<OrgAdminEventDetails />} />
        </Route>

        {/* Design System Preview Routes (from Builder.io) */}
        <Route path="/design-preview/dashboard" element={<RequireAdminRole><RLEventsDashboard /></RequireAdminRole>} />
        <Route path="/design-preview/tournaments" element={<RequireAdminRole><RLEventsTournaments /></RequireAdminRole>} />
        <Route path="/design-preview/create-event" element={<RequireAdminRole><RLEventsCreateEvent /></RequireAdminRole>} />
        <Route path="/design-preview/editor" element={<RequireAdminRole><RLEventsEventEditor /></RequireAdminRole>} />
        <Route path="/design-preview/flow-builder" element={<RequireAdminRole><RLEventsFlowBuilder /></RequireAdminRole>} />

        {/* Admin Dashboard Routes */}
        {/* Pool print page — no admin chrome. */}
        <Route path="/admin-dashboard/events/:eventId/divisions/:division/pools/:poolId/print" element={<ProtectedRoute><DivisionPoolPrintScreen /></ProtectedRoute>} />
        <Route path="/admin-dashboard" element={<ProtectedRoute><AdminAreaLayout /></ProtectedRoute>}>
          <Route index element={<AdminDashboardHome />} />
          <Route path="organizations" element={<AdminOrganizations />} />
          <Route path="organizations/:orgId" element={<AdminOrganizationDetail />} />
          <Route path="hub" element={<AdminDashboardHub />} />
          <Route path="sales-overview" element={<AdminSalesOverview />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="users" element={<UsersManagement />} />
          <Route path="email-templates" element={<Navigate to="/admin/communications" replace />} />
          <Route path="profile-features" element={<ProfileFeaturesManagement />} />
          <Route path="communication-hub" element={<Navigate to="/admin/communications" replace />} />
          <Route path="communication-templates" element={<Navigate to="/admin/communications" replace />} />
          <Route path="email-headers-footers" element={<EmailHeadersFooters />} />
          <Route path="communication/templates" element={<OrgEmailTemplatesPage />} />
          <Route path="communication/templates/:templateId" element={<OrgEmailTemplateEditPage />} />
          <Route path="communication/branding" element={<OrgEmailBrandingPage />} />
          <Route path="registrations" element={<RegistrationDashboardPage />} />
          <Route path="live-sheets" element={<LiveSheetsHub />} />

          <Route path="communication-triggers" element={<CommunicationTriggersManagement />} />
          <Route path="template-cleanup" element={<TemplateCleanup />} />
          <Route path="newsletter-schedules" element={<NewsletterSchedules />} />
          <Route path="social-media" element={<SocialMediaManagementPage />} />
          <Route path="communication-subscribers" element={<CommunicationSubscribersManagement />} />
          <Route path="advertising" element={<AdvertisingManagement />} />
          
          <Route path="communication-analytics" element={<CommunicationAnalyticsManagement />} />
          <Route path="communication-integrations" element={<CommunicationIntegrationsManagement />} />
          <Route path="sales-funnels" element={<SalesFunnelsManagement />} />
          <Route path="events" element={<RLeventsTournamentsPage />} />
          <Route path="events/new" element={<RLeventsCreateEventPage />} />
          <Route path="events/new/edit" element={<RLeventsEventEditorPage />} />
          <Route path="events/:eventId" element={<OperatorEventOverviewPage />} />
          <Route path="events/:eventId/edit" element={<RLeventsEventEditorPage />} />
          <Route path="events/:eventId/teams" element={<EventTeamsPage />} />
          <Route path="sheets/all-events" element={<AllEventsSheetPage />} />
          <Route path="events/:eventId/registrations" element={<OperatorEventRegistrationsPage />} />
          <Route path="events/:eventId/conflicts" element={<OperatorEventConflictAnalyzerPage />} />
          <Route path="events/:eventId/schedule-setup" element={<OperatorEventScheduleSetupPage />} />
          <Route path="events/:eventId/venues-courts" element={<OperatorEventVenuesCourtsPage />} />
          <Route path="events/:eventId/officials" element={<ModuleGuard module="officials"><OperatorEventOfficialsHubPage /></ModuleGuard>} />
          <Route path="events/:eventId/officials-legacy" element={<ModuleGuard module="officials"><OperatorEventOfficialsPage /></ModuleGuard>} />
          <Route path="events/:eventId/verification" element={<ModuleGuard module="player_verification"><OperatorEventVerificationPage /></ModuleGuard>} />
          <Route path="events/:eventId/hotels" element={<ModuleGuard module="hotels"><OperatorEventHotelsPage /></ModuleGuard>} />
          <Route path="events/:eventId/event-ops" element={<ModuleGuard module="event_ops"><OperatorEventOpsPage /></ModuleGuard>} />



          <Route path="events/:eventId/schedule-draft" element={<RouteErrorBoundary name="Build Schedule"><OperatorEventScheduleDraftPage /></RouteErrorBoundary>} />
          {/* Scheduling — each screen its own URL: grid, bulk edit, save/restore. */}
          <Route path="events/:eventId/scheduling" element={<RouteErrorBoundary name="Scheduling"><OperatorEventSchedulingStartPage /></RouteErrorBoundary>} />
          {/* Brackets, every division on one page — must beat the :section route below. */}
          <Route path="events/:eventId/scheduling/brackets" element={<RouteErrorBoundary name="Brackets"><OperatorEventBracketsPage /></RouteErrorBoundary>} />
          {/* Pools, on its own page — must beat the :section route below. */}
          <Route path="events/:eventId/scheduling/pools" element={<RouteErrorBoundary name="Pools"><OperatorEventPoolsPage /></RouteErrorBoundary>} />
          {/* One team's whole weekend, read only — must beat the :section route below. */}
          <Route path="events/:eventId/scheduling/team-summary" element={<RouteErrorBoundary name="Team summary"><OperatorEventTeamSummaryPage /></RouteErrorBoundary>} />
          {/* The old everything-page is retired; anyone holding the link lands on the grid. */}
          <Route path="events/:eventId/scheduling/overview" element={<NavigateToGrid />} />
          <Route path="events/:eventId/scheduling/:section" element={<RouteErrorBoundary name="Scheduling"><OperatorEventScheduleDraftPage /></RouteErrorBoundary>} />
          {/* Divisions — two-pane, deep-linkable, one screen per URL. */}
          <Route path="events/:eventId/divisions" element={<RouteErrorBoundary name="Divisions"><EventDivisionsLayout /></RouteErrorBoundary>}>
            <Route path=":division" element={<Navigate to="details" replace />} />
            <Route path=":division/details" element={<DivisionDetailsScreen />} />
            <Route path=":division/teams" element={<DivisionTeamsScreen />} />
            <Route path=":division/pools" element={<DivisionPoolsScreen />} />
            <Route path=":division/pools/assign" element={<DivisionPoolsAssignScreen />} />
            <Route path=":division/pools/:poolId/round-robin" element={<DivisionPoolRoundRobinScreen />} />
            <Route path=":division/pool-games" element={<DivisionPoolGamesScreen />} />
            <Route path=":division/bracket-games" element={<DivisionBracketGamesScreen />} />
            <Route path=":division/bracket" element={<DivisionBracketScreen />} />
            <Route path=":division/restrictions" element={<DivisionRestrictionsScreen />} />
            <Route path=":division/places" element={<DivisionPlacesScreen />} />
          </Route>
          <Route path="events/:eventId/schedule-review" element={<ScheduleReviewRedirect />} />
          <Route path="events/:eventId/post-scores" element={<OperatorPostScoresPage />} />
          <Route path="events/:eventId/print-pack" element={<RouteErrorBoundary name="Print Pack"><OperatorEventPrintPackPage /></RouteErrorBoundary>} />
          <Route path="events/:eventId/scheduling-requests" element={<EventSchedulingRequestsPage />} />
          <Route path="events/:eventId/messages" element={<EventMessagesPage />} />
          <Route path="events/:eventId/credentials-coaches" element={<EventCredentialsCoachesPage />} />
          <Route path="event-types" element={<EventTypesManagement />} />
          <Route path="event-categories" element={<EventCategoriesManagement />} />
          <Route path="event-discount-policies" element={<EventDiscountPoliciesManagement />} />
          <Route path="divisions" element={<DivisionsCatalogPage />} />
          <Route path="constraints" element={<RequireAdminRole><ConstraintsCatalogPage /></RequireAdminRole>} />
          <Route path="faqs" element={<RequireAdminRole><FaqCatalogPage /></RequireAdminRole>} />
          <Route path="waivers" element={<RequireAdminRole><WaiverCatalogPage /></RequireAdminRole>} />
          <Route path="extras-catalog" element={<ExtrasCatalogPage />} />
          <Route path="event-coupons" element={<EventCouponsManagement />} />
          <Route path="coupons" element={<CouponsPage />} />
          <Route path="master-teams" element={<MasterTeamsPage />} />
          <Route path="teams" element={<OrgTeamsPage />} />
          <Route path="records" element={<RecordsManagement />} />
          <Route path="photos" element={<PhotosPlaceholder />} />
          <Route path="coach-packets" element={<CoachPacketsPlaceholder />} />
          <Route path="event-management" element={<ModuleGuard module="event_ops"><ResourcesPlaceholder /></ModuleGuard>} />
          <Route path="hotel-partners" element={<ModuleGuard module="hotels"><AdminHotelPartnersPage /></ModuleGuard>} />
          <Route path="circuits" element={<ModuleGuard module="circuits"><CircuitsManagement /></ModuleGuard>} />
          <Route path="circuits/:circuitId" element={<ModuleGuard module="circuits"><CircuitDetailPage /></ModuleGuard>} />
          <Route path="hotels" element={<ModuleGuard module="hotels"><ProtectedRoute><HotelPartnerDashboard /></ProtectedRoute></ModuleGuard>} />
          <Route path="hotels/:eventId" element={<ModuleGuard module="hotels"><ProtectedRoute><HotelPartnerDashboard /></ProtectedRoute></ModuleGuard>} />
          <Route path="event-sponsors" element={<EventSponsorsManagement />} />
          <Route path="events/faqs" element={<EventFAQsPage />} />
          <Route path="events/analytics" element={<EventAnalyticsDashboard />} />
          <Route path="events/finance" element={<EventFinancePage />} />
          <Route path="events/:eventId/finance" element={<EventFinancePage />} />
          <Route path="events/packet-management" element={<PacketManagementPage />} />
          <Route path="notifications" element={<NotificationsPage />} />

          <Route path="venues" element={<VenueManagement />} />
          <Route path="staff" element={<ModuleGuard module="staff_portal"><StaffAdminPage /></ModuleGuard>} />
          <Route path="staff-directory" element={<ModuleGuard module="staff_portal"><StaffManagementPage /></ModuleGuard>} />

          <Route path="sport-cover-photos" element={<SportCoverPhotosPage />} />
          <Route path="advertising/assets" element={<AdAssetsPage />} />
          <Route path="advertising/performance" element={<AdPerformancePage />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="modules" element={<ModulesSettings />} />
          <Route path="roles" element={<AdminRolesManagement />} />
          <Route path="vendors/scouts" element={<ScoutManagement />} />
          <Route path="vendors/video" element={<VideoVendorManagement />} />
          <Route path="vendor-graphics-management" element={<GraphicsVendorManagement />} />
          <Route path="vendors/editors" element={<EditorsManagement />} />
          <Route path="affiliates" element={<AffiliateManagement />} />
          <Route path="may-event-admin" element={<MayEventAdmin />} />
          <Route path="events/registration-forms" element={<RegistrationFormsPage />} />
          <Route path="events/special-requests" element={<EventSpecialRequestsView />} />
          <Route path="tournaments" element={<ModuleGuard module="brackets"><TournamentManagementPage /></ModuleGuard>} />
          <Route path="rlhoops-points" element={<RLHoopsPointEntry />} />
          <Route path="leaderboards" element={<LeaderboardsManagement />} />
          <Route path="leaderboards/builder" element={<LeaderboardBuilder />} />
          <Route path="leaderboards/:id/entries" element={<LeaderboardEntries />} />
          <Route path="videos" element={<VideosManagement />} />
          <Route path="sports-hubs" element={<SportsHubsManagementPage />} />
          <Route path="sports-hub-messages" element={<SportsHubMessagesManagementPage />} />
          <Route path="issue-tracker" element={<IssueTracker />} />
          
          {/* Event Management Routes */}
          <Route path="event-management" element={<ModuleGuard module="event_ops"><EventManagementOverview /></ModuleGuard>} />
          <Route path="event-management/inventory" element={<ModuleGuard module="event_ops"><EventManagementInventory /></ModuleGuard>} />
          <Route path="event-management/staffing" element={<EventManagementStaffing />} />
          <Route path="event-management/travel" element={<EventManagementTravel />} />
          <Route path="event-management/officials" element={<ModuleGuard module="officials"><EventManagementOfficials /></ModuleGuard>} />
          <Route path="event-management/scorekeepers" element={<EventManagementScorekeepers />} />
          <Route path="event-management/checklists" element={<ModuleGuard module="event_ops"><EventManagementChecklists /></ModuleGuard>} />
          <Route path="event-management/expenses" element={<EventManagementExpenses />} />
          
        </Route>
        
        {/* Admin routes for memberships, AI knowledge, camps and colleges - Updated to use AdminDashboardLayout as nested route */}
        {/* NEW Modular Dashboard - Top level route */}
        <Route path="/modular-dashboard" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route path="events/create" element={<CreateEventPage />} />
          <Route path="events/:slug" element={<AdminEventDetails />} />
        </Route>
        
        {/* Staff big-button launcher home (mobile-first) */}
        <Route path="/staff/home" element={<ProtectedRoute><StaffHomeLayout /></ProtectedRoute>}>
          <Route index element={<StaffHome />} />
        </Route>

        {/* Staff Dashboard Routes */}
        <Route path="/staff" element={<ProtectedRoute><StaffLayout /></ProtectedRoute>}>
          <Route path="dashboard" element={<StaffDashboard />} />
          <Route path="check-in" element={<ModuleGuard module="check_in" redirectTo="/staff/home"><StaffCheckInPage /></ModuleGuard>} />
          <Route path="check-in-sheets" element={<StaffLiveSheetsPage />} />
          <Route path="registrations/:eventId" element={<StaffRegistrations />} />
          <Route path="registrations/:eventId/edit" element={<StaffEditRegistrations />} />
          <Route path="manage/:eventId" element={<StaffManageEvent />} />
          <Route path="reports/:eventId" element={<StaffViewReports />} />
          <Route path="events/:eventId" element={<StaffTournamentPage />} />
          <Route path="scoring/:eventId" element={<ModuleGuard module="live_scoring" redirectTo="/staff/home"><StaffTournamentPage /></ModuleGuard>} />
          <Route path="checkin/:eventId" element={<StaffEventCheckInPage />} />
          {/* Legacy redirect: old /staff/tournaments/:eventId path */}
          <Route path="tournaments/:eventId" element={<StaffTournamentsRedirect />} />
        </Route>
        

        {/* Admin Demo Data Management - Redirect to new location */}
        <Route path="/admin/demo-data" element={<Navigate to="/demo/data" replace />} />

        {/* NEW MODULAR EVENT MANAGEMENT - Unified event management page */}
        <Route path="/admin/events/:eventId/manage" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route index element={<RLeventsEventEditorPage />} />
        </Route>
        
        {/* Event Pricing Configuration - standalone admin route */}
        <Route path="/admin/events/:eventId/pricing" element={<ProtectedRoute><EventPricingConfig /></ProtectedRoute>} />
        <Route path="/admin/live-sheets" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route index element={<AdminLiveSheetsPage />} />
        </Route>
        
        {/* Event Registrations Management */}
        <Route path="/admin/events/:eventId/registrations" element={<ProtectedRoute><EventRegistrationsAdmin /></ProtectedRoute>} />

        {/* Event Day-of Check-In */}
        <Route path="/admin/events/:eventId/checkin" element={<ProtectedRoute><EventCheckInPage /></ProtectedRoute>} />
        
        {/* Event Rosters Management */}
        <Route path="/admin/events/:eventId/rosters" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route index element={<EventRostersAdmin />} />
        </Route>
        
        {/* Payments & Analytics */}
        <Route path="/admin/registrations" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route index element={<EventRegistrationsAdmin />} />
        </Route>
        
        
        {/* Legacy redirects to unified communications */}
        <Route path="/admin/events/communications" element={<Navigate to="/admin/communications" replace />} />
        <Route path="/admin/email-templates" element={<Navigate to="/admin/communications" replace />} />

        <Route path="/admin" element={<ProtectedRoute><AdminDashboardLayout /></ProtectedRoute>}>
          <Route path="mikes-dash" element={<MikesDashboard />} />
          <Route path="staff" element={<StaffManagement />} />
          <Route path="email-templates" element={<Navigate to="/admin/communications" replace />} />
          <Route path="test-notifications" element={<TestNotificationsPage />} />
          <Route path="organizations" element={<AdminOrganizations />} />
          <Route path="organizations/:orgId" element={<AdminOrganizationDetail />} />
          <Route path="newsletter-schedules" element={<NewsletterSchedules />} />
          <Route path="events/packet-management" element={<PacketManagementPage />} />
          <Route path="messages/templates" element={<MessageTemplatesPage />} />
          <Route path="messages/templates/:templateId" element={<MessageTemplateEditPage />} />
        </Route>

        {/* Add Gmail Callback Route */}
        <Route path="/gmail-callback" element={<GmailCallbackPage />} />

        {/* Claim Coach Profile - Public Route */}
        <Route path="/claim-coach-profile" element={<ClaimCoachProfile />} />

        {/* Parent Athlete Impersonation Route - must be outside other wrappers */}
        <Route path="/parent-athlete-impersonation/:athleteId" element={<ParentAthleteImpersonation />} />

        {/* Parent Athlete View Route */}
        <Route path="/parent-athlete-view/:athleteId" element={<ParentAthleteView />} />

        {/* Auth routes (no layout) */}
        <Route path="/auth/login" element={<PublicRoute><AuthLoginPage /></PublicRoute>} />
        {/* /auth/register redirected above to /login */}
        <Route path="/auth/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
        {/* Reset password routes handled at top level - outside GlobalLayout */}
        <Route path="/auth/set-password" element={<SetPassword />} />
        <Route path="/auth/email-verification" element={<PublicRoute><EmailVerificationPage /></PublicRoute>} />
        
        {/* For backward compatibility */}
        <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
        {/* Reset password routes handled at top level - outside GlobalLayout */}
        <Route path="/email-verification" element={<PublicRoute><EmailVerificationPage /></PublicRoute>} />
        <Route path="/profile-setup" element={<ProfileSetup />} />
        
        {/* Feedback submission route - make it accessible from both paths */}
        <Route path="/feedback/submit/:token" element={<SubmitFeedback />} />
        <Route path="/athlete-dashboard/feedback/submit/:token" element={<SubmitFeedback />} />

        {/* Catch-all: show a real 404 page instead of a blank body */}
        <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster />
            </RoleProvider>
            </AdminImpersonationProvider>
            </OrgModulesProvider>
          </OrganizationProvider>

        </GlobalLayout>
      } />
    </Routes>
  );
}

export default App;
